export default __webpack_public_path__ + "static/broszury-bg-a8f1b21d5621bff6f66f2fd9aa590835.jpg";